import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// components
import HeaderNavbar from './components/Navbar';
import Footer from './components/Footer';
// pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import BestSellerPage from './components/BestSellerPage';
import SearchPage from './components/SearchPage';
import UserBooksPage from './components/UserBooksPage';
import BookDetailsPage from './pages/Details';
import NotFound from './pages/NotFound';
// user context
import UserProvider from './userContext';

// styles
import { GlobalStyle } from './GlobalStyle';
import { Wrapper, Content } from './App.Styles';

const App = () => {
  return (
    <Router>
      <Wrapper>
        <UserProvider>
          <HeaderNavbar />
          <Content>
            <Routes>
              <Route path='/' element={<Landing />} />
              <Route path='login' element={<Login />} />
              <Route path='sign-up' element={<SignUp />} />
              <Route path='forgot-password' element={<ForgotPassword />} />
              <Route
                path='reset-password/:resetToken'
                element={<ResetPassword />}
              />
              <Route path='home' element={<Home />}>
                <Route index element={<BestSellerPage />} />
                <Route path='best-seller' element={<BestSellerPage />}></Route>
                <Route path='discover' element={<SearchPage />} />
                <Route path='reading' element={<UserBooksPage />} />
                <Route path='plan-to-read' element={<UserBooksPage />} />
                <Route path='finished' element={<UserBooksPage />} />
              </Route>
              <Route path='books/:bookId' element={<BookDetailsPage />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
          </Content>
          <GlobalStyle />
        </UserProvider>
        <Footer />
      </Wrapper>
    </Router>
  );
};

export default App;
